<template>
  <b-alert :show="messages.length > 0" :variant="type" class="app-message-view">
    <slot name="beforeMessage"></slot>
    <button v-if="showDeleteButton" @click="clearMessages" class="close close-btn" type="button" aria-label="Close">
      <span aria-hidden="true">×</span>
    </button>
    <BIconExclamationCircleFill :variant="type" v-if="showIcon" class="alert-icon"></BIconExclamationCircleFill>
    <ul class="message-list">
      <li class="message-item" v-for="(message) in messages" v-bind:key="message.__uuid">
        <span v-if="message.message" v-html="message.message"></span>
        <a v-if="message.messageLink" @click="showModal(message)" class="message-link"> {{ message.messageLink }} </a>
      </li>
    </ul>
    <slot name="afterMessage"></slot>
    <variable-modal
      v-if="show"
      :show.sync = show
      :content = modalContent
      :actions = "createActions()"
      @click:close="closeModal()"
    ></variable-modal>
  </b-alert>
</template>
<script>

import { BAlert, BIconExclamationCircleFill } from 'bootstrap-vue'
import VariableModal from '@/components/generic/VariableModal'

export default {
  name: 'MessageListComponent',
  data () {
    return {
      show: false,
      modalContentText: null,
      modalTitle: null
    }
  },
  components: {
    VariableModal,
    BAlert,
    BIconExclamationCircleFill
  },
  computed: {
    modalContent: function () {
      return {
        title: this.modalTitle || 'Achtung!',
        class: 'message-box-modal',
        modalContentText: this.modalContentText
      }
    }
  },
  props: {
    messages: {
      type: Array
    },
    type: {
      type: String,
      default: 'danger'
    },
    clearMutation: {
      type: String,
      default: 'clearMessages'
    },
    showDeleteButton: {
      type: Boolean,
      default: false
    },
    showIcon: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    clearMessages () {
      this.$store.commit(this.clearMutation, {})
    },
    showModal (message) {
      this.show = true
      this.modalContentText = message.messageModalContent
    },
    closeModal () {
      this.show = false
    },
    createActions () {
      return [
        {
          type: 'close',
          text: 'Schließen'
        }
      ]
    }
  }
}
</script>
